import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';
import SelectButton from '../SelectButton';
import UnselectButton from '../UnselectButton';
import lockIcon from './icon-locked-cart.svg';
import { Link } from 'react-router-dom';

export const InCartTemplateRow = ({
  formattedTotal,
  totalQuantity,
  priorityLabel,
  modelNameByTemplateId,
  selectTemplate,
  unselectTemplate,
  locked,
  selectedTemplate,
  selectableTemplate,
  toggleMoreOptions,
  templateId,
  modelUrl,
  editString,
  functionalGroupCodes,
  designPackage,
  designPackageKeys,
  mini,
  editStyle,
}) => {
  return (
    <div className={styles.templateView}>
      <div className={styles.template}>
        {!mini && (
          <span className={styles.modelName}>{modelNameByTemplateId}</span>
        )}
        <span className={styles.optionClusterString}>
          {functionalGroupCodes.map(code => (
            <span key={`${templateId}${code}`} className={styles.fgcode}>
              {code}
            </span>
          ))}
        </span>
        <span className={styles.designPackage}>
          {designPackageKeys.map(
            optionKey =>
              designPackage[optionKey] ? (
                <span key={optionKey} className={styles.designElement}>
                  <img
                    className={styles.optionIcon}
                    alt="designOption"
                    src={designPackage[optionKey].imgUrl}
                  />
                  {designPackage[optionKey].id}
                </span>
              ) : (
                <span key={optionKey} className={styles.designElement} />
              ),
          )}
        </span>
        <span className={styles.totalPrice}>{formattedTotal}</span>
        <span className={styles.selectedQuantityStatic}>{totalQuantity}</span>
        <span className={styles.priority}>{priorityLabel}</span>

        <Link className={styles.editLink} to={modelUrl}>
          <span style={editStyle}>{editString}</span>
        </Link>

        <span className={styles.buttonColumn}>
          {selectedTemplate && (
            <UnselectButton unselectTemplate={unselectTemplate} mini={mini} />
          )}
          {selectableTemplate && (
            <SelectButton selectTemplate={selectTemplate} mini={mini} />
          )}
          {locked && (
            <button className={styles.locked}>
              <img alt="lock" src={lockIcon} />
            </button>
          )}
        </span>
      </div>
    </div>
  );
};

InCartTemplateRow.propTypes = {
  formattedTotal: PropTypes.string.isRequired,
  totalQuantity: PropTypes.number.isRequired,
  priorityLabel: PropTypes.string.isRequired,
  designPackage: PropTypes.object.isRequired,
  designPackageKeys: PropTypes.array.isRequired,
  modelNameByTemplateId: PropTypes.string.isRequired,
  selectTemplate: PropTypes.func.isRequired,
  unselectTemplate: PropTypes.func.isRequired,
  locked: PropTypes.bool.isRequired,
  selectedTemplate: PropTypes.bool.isRequired,
  selectableTemplate: PropTypes.bool.isRequired,
  modelUrl: PropTypes.string.isRequired,
  editString: PropTypes.string.isRequired,
};

export default enhance(InCartTemplateRow);
